import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-18fec7a7")

_pushScopeId("data-v-18fec7a7")
const _hoisted_1 = { class: "shopping-category-list-item" }
const _hoisted_2 = { class: "shopping-category-list-item-title" }
const _hoisted_3 = { class: "shopping-category-list-item-title-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ShoppingIngredientListItem = _resolveComponent("ShoppingIngredientListItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.categoryTitle), 1)
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.foodList, (food) => {
      return (_openBlock(), _createBlock(_component_ShoppingIngredientListItem, {
        key: food.id,
        id: food.id,
        foodId: food.foodId,
        check: food.isChecked,
        ingredientName: food.name,
        hasStock: food.hasStock,
        onCheckClick: _ctx.checkClick,
        onEditClick: _ctx.editClick
      }, null, 8, ["id", "foodId", "check", "ingredientName", "hasStock", "onCheckClick", "onEditClick"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})